import { LoaderWrapper } from '../Loader';

interface AbsoluteScreenLoaderProps {
    className?: string;
}

export const AbsoluteScreenLoader = ({ className }: AbsoluteScreenLoaderProps) => {
    return <LoaderWrapper className={className} absolute />;
};
